import { render, staticRenderFns } from "./onlineEditForm.vue?vue&type=template&id=d5204c32&"
import script from "./onlineEditForm.vue?vue&type=script&lang=js&"
export * from "./onlineEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports